import {
  combineReducers,
  configureStore,
  getDefaultMiddleware,
} from "@reduxjs/toolkit";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";

import storage from "redux-persist/lib/storage";

import userReducer from "./user";
import parallaxReducer from "./parallax";
import shopifyReducer from "./shopify";
import labelsReducer from "./labels";
import localeReducer from "./locale";
import modalsReducer from "./modals";
import fontsReducer from "./fontFamily";

const persistConfig = {
  key: "root",
  version: 1,
  storage,
  whitelist: ["shopify", "modals"],
};

const rootReducer = combineReducers({
  user: userReducer,
  parallax: parallaxReducer,
  shopify: shopifyReducer,
  labels: labelsReducer,
  locale: localeReducer,
  styles: fontsReducer,
  modals: modalsReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: getDefaultMiddleware({
    serializableCheck: {
      ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
    },
  }),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
